import { Logo } from "@/components/display";
import { Form, useForm } from "@/components/form";
import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { Card, Stack, Typography } from "@mui/material";
import { z } from "zod/v4";

const loginFormSchema = z.object({
    email: z.string().nonempty("Este campo es requerido"),
    password: z.string().nonempty("Este campo es requerido")
})

export default function LoginPage() {

    const { login } = useAuthContext();

    const loginForm = useForm({
        defaultValues: {
            email: "",
            password: ""
        },
        onSubmit: async ({ value }) => await login(value),
        validators: {
            onSubmit: loginFormSchema
        },
        submitOnce: true
    });

    return <Stack justifyContent={"center"} alignItems={"center"} sx={{ backgroundColor: "primary.light", minHeight: "100vh" }}>
        <Card sx={{ width: "100%", maxWidth: "400px" }}>
            <Form form={loginForm} gap={3} padding={5}>
                <Stack flexDirection={"column"} gap={2}>
                    <Logo alignSelf={"center"} />
                    <Typography component="h1" variant="h4">Iniciar Sesión</Typography>
                </Stack>
                <Form.EmailField name="email" label="Email" />
                <Form.PasswordField name="password" label="Contraseña" placeholder="Contraseña" />
                <Form.SubmitButton>Iniciar Sesión</Form.SubmitButton>
            </Form>
        </Card>
    </Stack>
}